<template>
  <div v-bind:style="footerCssHeight">
    <div id="footer">
      <div class="container">
        <div class="row needs-padding-top">
          <div class="col-md-4  my-auto">
           <router-link to="/claimsearch">
             <p class="footer-text">Claim Your Business</p>
           </router-link>
          </div>
          <div class="col-md-4 my-auto">
            <router-link to="/faq">
              <p class="footer-text">FAQ</p>
            </router-link>
          </div>
          <div class="col-md-4  my-auto">
            <router-link to="/contact">
              <p class="footer-text">Contact Us</p>
            </router-link>
          </div>
        </div>
        <div class="row">
         <div class="col-md-4 my-auto">
           <a href="https://www.linkedin.com/company/yarlow" target="_blank"><i class="fab fa-linkedin"></i></a>
           <a href="https://www.facebook.com/YarlowApp" target="_blank"><i class="fab fa-facebook"></i></a>
           <a href="https://www.youtube.com/@yarlowapp" target="_blank"><i class="fab fa-youtube"></i></a>
           <a href="https://www.instagram.com/yarlowapp" target="_blank"><i class="fab fa-instagram"></i></a>
         </div>
          <div class="col-md-4 my-auto">
            <router-link to="/terms">
              <p class="footer-text">Terms of Use</p>
            </router-link>
          </div>
          <div class="col-md-4  my-auto">
            <img class="realtor-image" src="/static/realtor1.jpg">
            <img class="realtor-image" src="/static/realtor2.png">
            <p class="d-inline footer-text">MN BRE #40609146</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <img src="/static/powered_by_google_on_white.png" alt="Google Attribution">
          </div>
          <div class="col-md-4 my-auto">
            <router-link to="/privacy">
              <p class="footer-text">Privacy Policy</p>
            </router-link>
          </div>
          <div class="col-md-4 my-auto">
            <p class="footer-text">Copyright © {{ new Date().getFullYear() }} Yarlow</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      footerHeight: 0
    }
  },
  computed: {
    footerCssHeight () {
      var height = this.footerHeight + 'px'
      return {
        'height': height
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.getFooterHeight)
    this.getFooterHeight()
  },
  methods: {
    getFooterHeight (event) {
      this.footerHeight = document.getElementById('footer').offsetHeight
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getFooterHeight)
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.realtor-image {
  width: 30px;
}

#footer {
  padding-bottom: 2rem;
  background-image: url("../assets/background.png");
  background-repeat: repeat;
  width: 100%;
  position: absolute;
  bottom:0;
}

hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border-width: 1px;
    border-style: solid;
    border-color: #a4a4a4;
}

hr, .fab, .footer-text {
  color: #a4a4a4 !important;
}

.needs-padding-top {
  padding-top: 2rem;
}

.fab {
  font-size: 28px;
  text-align: center;
  text-decoration: none;
  padding-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue